import type { FaireProductEntity } from "../../entity_types/product";

export const p_jzdycrxdbt: FaireProductEntity = {
  token: "p_jzdycrxdbt",
  type: "product",
  name: "Knotted Baby Gown - Arona Blue Ribbed",
  brandToken: "b_a1cy3tx6q8",
  brandName: "Harp Angel Boutique",
  imageUrl:
    "https://cdn.faire.com/fastly/18eafffd5329888b3810eb097e1dd607faaa801119af51bf5856cb4a090eae59.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f89ff719a83b5c796d119ae137b1e5e98c82db9ba2442a6073d589177fa93e06.jpeg",
    "https://cdn.faire.com/fastly/fb17a389f381a3186d94fe0153848c12bdc1cae18da7eb4a1b23da447328efa9.jpeg",
    "https://cdn.faire.com/fastly/b473d13f4a661691efc807295058df19408bd365d48785f494a58192a61c19a7.png",
    "https://cdn.faire.com/fastly/0e907768aba806b9f12252854a2de0186de4923d621811c093af9cfe6ca51146.png",
    "https://cdn.faire.com/fastly/45cf8288abb79588fe56a8fbdf962f8277fa89fc4e4bfb743e6fb2fc4f5ddf13.jpeg",
  ],
  priceDollars: 14.3,
  description:
    "\nOur Dusty Blue Bamboo knotted baby gown makes the perfect going home outfit or gift! Made from naturally soft and lightweight bamboo viscose material to keep your baby comfortable. Featuring fold over cuffs to keep baby from scratching and to keep their little hands warm. The knotted bottom can grow with your child and makes diaper changing a breeze! \n\n***Accessories shown sold separately***\n\n * Size 0-3 months (fits 7-12 lbs)﻿ \n\n",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:05.283Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
